import { api } from "@data-phone/react-resource-server-auth";
import dayjs from "dayjs";
import useApiQuery from "hooks/useApiQuery";

import qs from "qs"

export interface StatSummary {
    queue: string | null;
    avg_wait_time: string;
    min_wait_time: string;
    max_wait_time: string;
    grouped_by: string[] | null;
}

export interface CallCenterStatsResponse {
    data: {
        summary: Array<StatSummary>;
    };
}

export const fetchCallCenterStats = async () => {
    const query = qs.stringify(
        {
            filters: {
                entertime: `${dayjs().startOf('day').toISOString()}~${dayjs().endOf('day').toISOString()}`,
            },
            fields: ["avg_wait_time", "min_wait_time", "max_wait_time"],
        },
        { encode: false }
    );

    const url = `${process.env.REACT_APP_REPORTING_URL}/qdr/stats?${query}`;
    const response = await api.get(url);
    return response as CallCenterStatsResponse;
};

export const useGetCallCenterStats = () => {
    return useApiQuery(
        ['call-center-stats'],
        fetchCallCenterStats,
        {}
    );
};
